import InstanceConfiguration from './InstanceConfiguration';

export default InstanceConfiguration;
